<p-card styleClass="validations-card">
  <div class="page-header">
    <div class="header-left">
      <span class="page-icon is-primary"><i class="fa-solid fa-file-signature" aria-hidden="true"></i></span>
      <div>
        <h1>Preofertas por autorizar</h1>
        <p class="header-subtitle">
          Preofertas de clientes nuevos con demandas, listas o la 32-D negativa: no salen sin Legal.
          <ng-container *ngIf="!canReview">Solo Legal las autoriza o regresa: aquí las ves en solo lectura.</ng-container>
        </p>
      </div>
    </div>
    <div class="header-right" role="group" aria-label="Filtrar por estado">
      <button
        *ngFor="let option of filters"
        pButton
        type="button"
        class="p-button-sm"
        [class.p-button-outlined]="option.value !== status"
        [attr.aria-pressed]="option.value === status"
        [label]="option.label"
        (click)="setStatus(option.value)"
        [attr.data-test]="'tray-filter-' + option.value"
      ></button>
    </div>
  </div>

  <p-divider></p-divider>

  <div class="empty-state" *ngIf="loading" data-test="tray-loading">
    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
    <span>Cargando la bandeja…</span>
  </div>

  <div class="empty-state is-error" *ngIf="!loading && loadError" role="alert" data-test="tray-error">
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
    <h3>No pudimos cargar la bandeja</h3>
    <span>{{ loadError }}</span>
    <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-refresh" label="Reintentar" (click)="load()"></button>
  </div>

  <div class="empty-state" *ngIf="!loading && !loadError && !items.length" data-test="tray-empty">
    <i class="fa-solid fa-inbox" aria-hidden="true"></i>
    <h3>{{ status === 'legal_review' ? 'No hay preofertas por autorizar' : 'No hay preofertas en este estado' }}</h3>
  </div>

  <div class="table-wrap" *ngIf="!loading && !loadError && items.length">
    <table class="tray-table">
      <caption class="p-hidden-accessible">
        Preofertas: cliente, su arrendamiento, monto preaprobado, disparador y desde cuándo esperan
      </caption>
      <thead>
        <tr>
          <th scope="col">Cliente</th>
          <th scope="col">Arrendamiento</th>
          <th scope="col">Monto preaprobado</th>
          <th scope="col">Disparador</th>
          <th scope="col">En espera desde</th>
          <th scope="col"><span class="p-hidden-accessible">Acciones</span></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of items; trackBy: trackById" data-test="tray-row">
          <td>
            <span class="client-name">{{ item.clientSummary?.name || 'Cliente no disponible' }}</span>
            <span class="client-rfc">{{ item.clientSummary?.rfc }}</span>
          </td>
          <td>
            <span *ngIf="item.leaseFolio; else noLease">{{ item.leaseFolio }}</span>
            <ng-template #noLease><span class="muted">Sin solicitud</span></ng-template>
          </td>
          <td class="amount">
            {{ item.expectedAmount !== null ? (item.expectedAmount | currency: 'MXN' : 'symbol-narrow' : '1.2-2') : '—' }}
            <p-tag
              *ngIf="item.capped"
              severity="warning"
              value="Tope"
              [pTooltip]="item.capacity ? 'Capacidad estimada ' + (item.capacity | currency: 'MXN' : 'symbol-narrow' : '1.0-0') : ''"
              data-test="tray-capped"
            ></p-tag>
          </td>
          <td>{{ (item.trigger && triggers[item.trigger]) || '—' }}</td>
          <td>{{ item.legalSince ? (item.legalSince | mxDate) : '—' }}</td>
          <td class="row-actions">
            <a
              pButton
              class="p-button-sm"
              [class.p-button-outlined]="!(canReview && item.status === 'legal_review')"
              [icon]="canReview && item.status === 'legal_review' ? 'pi pi-check-square' : 'pi pi-eye'"
              [label]="canReview && item.status === 'legal_review' ? 'Revisar' : 'Ver'"
              [routerLink]="['/preofertas/legal', item._id]"
              data-test="tray-open"
            ></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</p-card>
